import apiClient from "./apiClient";

export const fetchExchangeRate = () => apiClient.get("/api/exchange_rate");

export const fetchBalance = (username) =>
    apiClient.get(`/api/balance/${username}`);

export const fetchCurrentRatio = (username) =>
    apiClient.get(`/api/current_ratio/${username}`);

export const fetchBalanceHistory = (username, params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.limit) queryParams.append("limit", params.limit);
    if (params.month) queryParams.append("month", params.month);
    if (params.start_date) queryParams.append("start_date", params.start_date);
    if (params.end_date) queryParams.append("end_date", params.end_date);
    const queryString = queryParams.toString();
    return apiClient.get(`/api/balance_history/${username}${queryString ? `?${queryString}` : ""}`);
};

export const fetchMonthlySummary = (username, params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.month) queryParams.append("month", params.month);
    if (params.start_date) queryParams.append("start_date", params.start_date);
    if (params.end_date) queryParams.append("end_date", params.end_date);
    const queryString = queryParams.toString();
    return apiClient.get(
        `/api/balance_history/${username}/monthly_summary${queryString ? `?${queryString}` : ""}`
    );
};

export const loginUser = (username, password) =>
    apiClient.post(
        "/api/user/token/",
        { username, password },
        {
            headers: {
                "Content-Type": "application/json",
            },
        }
    );
